import { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { noop } from 'lodash';
import useSidebarButtons from 'components/Sidebar/hooks/useSidebarButtons';
import { Flex } from 'components/base/layout-components';
import Logo from 'components/Sidebar/Logo';
import SidebarButtons from 'components/Sidebar/SidebarButtons';
import { SidebarMenu } from '@linearb/linui-common';
import {
  SIDEBAR_WIDTH,
  SIDEBAR_WIDE_WIDTH,
  SIDEBAR_COLLAPSED_ZINDEX
} from 'common/constants/SidebarView';
import useSidebarState from 'components/Sidebar/hooks/useSidebarState';
import { isSurveyFlow } from 'common/utils/utils';

const Sidebar = () => {
  const history = useHistory();
  const { isSidebarPinned } = useSidebarState();
  const [sidebarExpanded, setSidebarExpanded] = useState(isSidebarPinned);
  const [anchorEl, setAnchorEl] = useState(null);
  const [clicked, setClicked] = useState<any>({});
  const [menuItems, setMenuItems] = useState([]);
  const [sidebarZIndex, setSidebarZIndex] = useState(SIDEBAR_COLLAPSED_ZINDEX);

  const sidebarRef = useRef(null);

  const handleLogoClick = () => {
    // @ts-expect-error
    setAnchorEl();
    setClicked({});
  };

  const handleMenuClose = () => {
    // @ts-expect-error
    setAnchorEl();
    setSidebarExpanded(isSidebarPinned || false);
    setSidebarZIndex(SIDEBAR_COLLAPSED_ZINDEX);
    setClicked({});
  };

  const handleMenuItemClick = ({ path, params, search, onClick = noop }) => {
    const pathname = params ? `${path}/${params}` : path;

    onClick();
    history.push({
      pathname,
      search
    });
    handleMenuClose();
  };

  const { navigationButtons, buttons } = useSidebarButtons();
  const sidebarWidth = sidebarExpanded ? SIDEBAR_WIDE_WIDTH : SIDEBAR_WIDTH;

  if (isSurveyFlow()) return <div />;

  return (
    <Flex position='relative'>
      <Flex
        className='sidebar-id'
        role='sidebar'
        position='absolute'
        width={sidebarWidth}
        height='100%'
        backgroundColor='white'
        ref={sidebarRef}
        style={{
          zIndex: sidebarZIndex,
          boxShadow: '0px 0px 10px 0px #3B599833',
          transition: '0.1s'
        }}
      >
        <Flex direction='column' width='100%'>
          <Flex direction='column' items='center' id='SidebarItems' grow='1'>
            <Logo sidebarExpanded={sidebarExpanded} onClick={handleLogoClick} />
            <SidebarButtons
              sidebarButtons={navigationButtons}
              sidebarExpanded={sidebarExpanded}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              menuItems={menuItems}
              setMenuItems={setMenuItems}
              clicked={clicked}
              setClicked={setClicked}
            />
          </Flex>
          <Flex
            direction='column'
            items='center'
            mb='0.5rem'
            borderTop='1px solid #EBEEF5'
          >
            <SidebarButtons
              sidebarButtons={buttons}
              sidebarExpanded={sidebarExpanded}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              menuItems={menuItems}
              setMenuItems={setMenuItems}
              clicked={clicked}
              setClicked={setClicked}
            />
          </Flex>
          {menuItems.length ? (
            <SidebarMenu
              menuId={clicked.id}
              isBorderTop={clicked.isBorderTop}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => handleMenuClose()}
              style={clicked.style}
              anchorOrigin={clicked.anchorOrigin}
              transformOrigin={clicked.transformOrigin}
              menuItems={menuItems}
              handleMenuItemClick={handleMenuItemClick}
              colorPalette={clicked.colorPalette}
            />
          ) : null}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Sidebar;
